import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import P from '@deliveroo/consumer-component-library/components/P';
import Input from '../../atoms/Input';
import Heading from '../../atoms/Heading';

import styles from './styles.scss';

export default function OrderHelpResolutions({
  onPickResolution,
  resolutions,
  selectedResolutionId,
  modal,
}) {
  return (
    <div className={classnames({ [styles.modal]: modal })}>
      <ul className={styles.resolutions}>
        {resolutions.map((resolution) => (
          <li
            key={resolution.id}
            className={classnames({ [styles.selected]: selectedResolutionId === resolution.id })}
          >
            <label htmlFor={`resolution-${resolution.id}`} className={styles.resolution}>
              <Input
                id={`resolution-${resolution.id}`}
                type="radio"
                onChange={() => onPickResolution(resolution)}
                checked={selectedResolutionId === resolution.id}
                className={styles.input}
              />
              <div className={styles.info}>
                {resolution.price !== null ? (
                  <Heading tag="h2" className={styles.price}>
                    {resolution.price}
                    <span className={styles.title}>{resolution.title}</span>
                  </Heading>
                ) : (
                  <span className={styles.title}>{resolution.title}</span>
                )}
                <P color="grey" size="small" spacing="0 0 small 0">
                  {resolution.subtitle}
                </P>
                <P isBold size="small">
                  {resolution.footer}
                </P>
              </div>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

OrderHelpResolutions.propTypes = {
  onPickResolution: PropTypes.func.isRequired,
  resolutions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      footer: PropTypes.string,
    }),
  ),
  selectedResolutionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modal: PropTypes.bool,
};

OrderHelpResolutions.defaultProps = {
  resolutions: [],
  selectedResolutionId: null,
  modal: false,
};
